import {
  CapaConsultingStartMethod,
  CapaQuotationUserBizType,
  CapaQuotationUserFile
} from '@generated/graphql';

export interface UserInfoData {
  id?: string;
  organizationName?: string;
  managerName?: string;
  email?: string;
  phoneNumber?: string;
  shortAddress?: string;
  bizType?: CapaQuotationUserBizType;
  companyIntroduction?: string;
  website?: string;
  files?: Array<CapaQuotationUserFile>;
}

export const ConsultingStartMethodEnum: {
  [key in CapaConsultingStartMethod]: string;
} = {
  [CapaConsultingStartMethod.OldConsulting]:
    '견적서 없이 상담을 할 수 있습니다',
  [CapaConsultingStartMethod.QuotationRequired]:
    '견적서를 제출한 파트너만 상담을 제안할 수 있습니다',
  [CapaConsultingStartMethod.PartnerIntroductionAvailable]:
    '견적서없이 회사소개서만으로 상담을 제안할 수 있습니다'
};
